<template>
    <SideFormSection>
        <template #title> Hosts </template>
        <template #subtitle>
            Select the users who can host this meeting.
        </template>
        <template #rawContent>
            <Card
                title="Hosts"
                iconName="user-tie"
            >
                <template #content>
                    <ApiForm
                        :url="
                            urlFactory.makeServiceAssociateCompanyUsersUrl(
                                serviceAggregate.service.id,
                            )
                        "
                        method="POST"
                        ref="apiFormRef"
                    >
                        <ServiceCompanyUserTable
                            :serviceId="serviceAggregate.service.id"
                            :companyUserAggregates="companyUserAggregates"
                        />
                    </ApiForm>
                </template>
                <template #actions>
                    <Button
                        @click="apiFormRef?.submit()"
                        :loading="apiFormRef?.loading.valueOf()"
                        iconName="save"
                        color="dark"
                    >
                        Save
                    </Button>
                </template>
            </Card>
        </template>
    </SideFormSection>
</template>

<script setup lang="ts">
    import { UrlFactory } from '@/Shared/Url/UrlFactory'
    import { ref, type PropType } from 'vue'
    import SideFormSection from '@/Shared/Component/SideFormSection.vue'
    import Card from '@/Shared/Component/Card.vue'
    import ServiceAggregate from '@/App/Service/Entity/ServiceAggregate'
    import ApiForm from '@/Shared/Component/Forms/ApiForm.vue'
    import Button from '@/Shared/Component/Button.vue'
    import CompanyUserAggregate from '@/App/CompanyUser/Entity/CompanyUserAggregate'
    import ServiceCompanyUserTable from '@/App/Service/Component/CompanyUser/ServiceCompanyUserTable.vue'
    import type { ApiFormRefType } from '@/Shared/AutoGenerated/Types'

    const props = defineProps({
        serviceAggregate: {
            type: Object as PropType<ServiceAggregate>,
            required: true,
        },
        companyUserAggregates: {
            type: Array as PropType<CompanyUserAggregate[]>,
            required: true,
        },
    })

    const apiFormRef = ref<ApiFormRefType>(null)
    const urlFactory = new UrlFactory()
</script>
